// Return environment as given in .env, unless its local
// Local will return as dev environment
export const getEnvironment = function(){

  const environment = process.env.REACT_APP_ENV || 'prd';

  if (environment === 'local') return 'dev';

  return environment;
};

export const getUserAuthInfo = function(){
    return {
        authId:  null
    }
};